<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import { CloseIcon } from '../icons';
  import { clickOutsideAction } from 'svelte-legos';
  import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
  import { FormattedText } from 'customer-components/lib';

  export let disclaimerModalContent: { html: string };

  const dispatch = createEventDispatcher();

  onMount(() => {
    disableBodyScroll(document.body);
  });

  onDestroy(() => {
    clearAllBodyScrollLocks();
  });
</script>

<div class="disclaimer-modal" transition:fade={{ duration: 150 }}>
  <div
    class="disclaimer-modal_content"
    in:fly={{ duration: 100, delay: 150, y: 100 }}
    out:fly={{ delay: 0, duration: 100, y: 100 }}
    use:clickOutsideAction={() => dispatch('close')}
  >
    <div class="disclaimer-modal_content_close">
      <button on:click={() => dispatch('close')}>
        <CloseIcon />
      </button>
    </div>
    <div class="disclaimer-modal_content_text">
      <FormattedText properties={{ html: disclaimerModalContent.html }} />
    </div>
  </div>
</div>

<style lang="scss">
  .disclaimer-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;
    backdrop-filter: blur(1px);

    &_content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 16px;
      border-radius: 8px;
      box-shadow: 0px 4px 8px 0px rgba(17, 17, 17, 0.02);
      height: 80%;
      overflow: auto;
      &_close {
        text-align: right;
        margin-bottom: 16px;
        button {
          background-color: transparent;
          border: none;
          cursor: pointer;
        }
      }

      &_text {
        overflow-y: auto;
        height: calc(100% - 52px);
      }
    }
  }
</style>
